module.exports = __webpack_public_path__ + "img/onboarding3.b0e9644a.png";